/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { hash, task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { get } from '@ember/object';
import { localCopy } from 'tracked-toolbox';

/**
 * @param {Model<User>}                 user
 * @param {Model<Location>}             location
 * @param {String}                      notificationType
 */
let NotificationPreferencesLoader = (_dec = localCopy('args.notificationType', 'host_notification'), (_class = class NotificationPreferencesLoader extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "notificationType", _descriptor2, this);
    _defineProperty(this, "query", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          installedPlugins,
          notificationPreferences
        } = yield hash({
          notificationPreferences: this.store.query('notification-preference', {
            filter: {
              relation_type: this.modelType,
              relation_id: get(this.model, 'id'),
              notification_type: this.notificationType
            }
          }),
          installedPlugins: this.store.query('plugin', {
            include: 'plugin',
            filter: {
              notification_channels: true
            },
            page: {
              limit: 100
            }
          })
        });
        return installedPlugins.sortBy('name').map((plugin, index) => {
          return {
            id: index,
            plugin: plugin,
            // There is no real relationship between plugin, model and
            // notification-preferences which force us to do the
            // binding manually.
            preference: this.findOrCreateNotificationPreference(plugin, notificationPreferences)
          };
        });
      }
    }), null, "query", null));
    this.query.perform();
  }
  get hasSomeEnabled() {
    const preferenceValues = this.query.lastSuccessful.value ?? [];
    return preferenceValues.some(p => p.preference.preferenceValue);
  }
  get modelType() {
    return this.args.location ? 'location' : 'user';
  }
  get model() {
    return this.args.location ?? this.args.user;
  }
  findOrCreateNotificationPreference(plugin, notificationPreferences) {
    const preference = notificationPreferences.findBy('notificationPlatformKey', get(plugin, 'key'));
    if (preference) return preference;
    return this.store.createRecord('notification-preference', {
      notificationPlatformKey: get(plugin, 'key'),
      notificationType: this.notificationType,
      preferenceValue: false,
      relationId: get(this.model, 'id'),
      relationType: this.modelType
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "notificationType", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { NotificationPreferencesLoader as default };